<template>
	<div class="title_bar is-flex is-justify-content-space-between is-align-items-center mb-4">
		<div class="is-flex is-align-items-center">
			<Ecs class="mr-2" style="width: 20px; height: 20px;" />
			<span class="tittle_section">{{ title }}</span>
		</div>
		<div class="table_actions is-flex">
			<button class="action_btn mr-2">
				<ChartLine class="mr-1" style="width: 16px; height: 16px;" />
				Comparación
			</button>
			<button class="action_btn mr-2">
				<ChartLine class="mr-1" style="width: 16px; height: 16px;" />
				Ver Gráfico
			</button>
			<div v-if="showPeriodSelect" style="min-width: 140px;">
				<SelectComponent :value="selectedPeriod" theme="report_theme"
					:options="periodOptions"
					@input="$emit('change-period', $event)" />
			</div>
		</div>
	</div>
</template>

<script>
import SelectComponent from "@/components/classification/SelectComponent";
import Ecs from "@/components/svg/Ecs.vue";
import ChartLine from "@/components/svg/ChartLine.vue";

export default {
	name: "EvolutionTableTitleBar",

	components: { SelectComponent, Ecs, ChartLine },

	props: {
		title: { type: String, required: true },
		selectedPeriod: { type: String, required: true },
		periodOptions: { type: Array, required: true },
		showPeriodSelect: { type: Boolean, default: true },
	},
};
</script>

<style scoped lang="scss">
.tittle_section {
	font-size: 18px;
	font-weight: 600;
}

.action_btn {
	background: var(--report-bg);
	border: 1px solid var(--report-border);
	border-radius: 8px;
	padding: 6px 12px;
	font-size: 14px;
	font-weight: 500;
	display: flex;
	align-items: center;
	cursor: pointer;

	&:hover { background: var(--report-surface); }
}
</style>
